import React from 'react';

import { useTheme } from 'styled-components';

import { SITE_KOREANAIR_SAVINGS, SITE_SKYPASS } from '@ecp/common/src/const/site/siteNumberConst';

import { useSiteComponentResolver } from '@mo-hooks/resolver/SiteComponentResolverHook';

import { ReactComponent as IconDefault } from '@ecp/common/src/assets/icon/icon__search-nofill.svg';
import { ReactComponent as IconSkypass } from '@ecp/common/src/assets/icon/skypass/icon_search.svg';

const SearchIcon = ({ ...rest }) => {
  const theme = useTheme();

  const ResolvedIcon = useSiteComponentResolver(<IconDefault { ...rest } fill={theme.color.icon.mo ?? '#141415'} />, {
    [SITE_SKYPASS]: <IconSkypass { ...rest } />,
    [SITE_KOREANAIR_SAVINGS]: <IconSkypass { ...rest } />,
  });

  return (
    <>
      {ResolvedIcon}
    </>
  );
};

export default SearchIcon;
